<template>
  <div>
    <div id="advancedFilters" aria-hidden="true" class="modal modal-right fade" role="dialog" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Filtri avanzati</h5>
            <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
          </div>
          <div class="modal-body">
            <div class="justify-content-center text-center">
              <button
                  class="btn btn-link text-warning px-0 mb-2"
                  type="button"
                  @click="resetFilters"
              >
                Resetta Filtri<i class="fad fa-times ms-1"></i>
              </button>
            </div>

            <div id="modal_search_advancedFilters" class="collapse show">
              <div class="d-flex gap-1 flex-wrap">

                <!-- Active -->
                <div class="mb-1 sw-14">
                  <label class="form-label mb-1 text-small" for="enabled">Attivi</label>
                  <select v-model="filters.enabled" class="form-select" @change="onFilterChange">
                    <option value="all">Tutti</option>
                    <option value="yes">Attivi</option>
                    <option value="no">Non attivi</option>
                  </select>
                </div>

                <!-- Out of production -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="outOfProduction">Produzione</label>
                  <select v-model="filters.outOfProduction" class="form-select" @change="onFilterChange">
                    <option value="">Tutti</option>
                    <option value="no">In prod</option>
                    <option value="yes">Fuori prod</option>
                  </select>
                </div>

                <!-- Has Images -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="hasImages">Immagini</label>
                  <select v-model="filters.hasImages" class="form-select" @change="onFilterChange">
                    <option value="">Tutti</option>
                    <option value="yes">Con immagini</option>
                    <option value="no">Senza immagini</option>
                  </select>
                </div>

                <!-- Status -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="productstatus">Stato</label>
                  <select v-model="filters.productstatus" class="form-select" @change="onFilterChange">
                    <option value="all">Tutti</option>
                    <option v-for="(status, key) in statusList" :key="key" :value="key">
                      {{ status }}
                    </option>
                  </select>
                </div>

                <!-- Brands -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="brand">Marche</label>
                  <select
                      id="brand"
                      v-model="filters.brand"
                      class="select2-with-tags w-md-auto"
                      multiple="multiple"
                      @change="onFilterChange"
                  >
                    <option v-for="brand in brands" :key="brand.id" :value="brand.id">
                      {{ brand.name }}
                    </option>
                  </select>
                </div>

                <!-- Tags -->
                <div class="mb-1">
                  <label class="form-label" for="tag">Tags</label>
                  <select
                      id="tag"
                      v-model="filters.tag"
                      class="select2-with-tags w-md-auto"
                      multiple="multiple"
                      @change="onFilterChange"
                  >
                    <option v-for="tag in tags" :key="tag.id" :value="tag.id">
                      {{ tag.name }}
                    </option>
                  </select>
                </div>

                <!-- Category -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="category">Categoria</label>
                  <select v-model="filters.category" class="form-select w-md-auto" @change="onFilterChange">
                    <option value="">Tipi ({{ subcategories.length }})</option>
                    <option v-for="subcategory in subcategories" :key="subcategory.id" :value="subcategory.id">
                      {{ subcategory.name }}
                    </option>
                  </select>
                </div>

                <!-- Wine lists -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="winelist">Carte dei vini</label>
                  <select
                      id="winelist"
                      v-model="filters.winelist"
                      class="select2-with-tags w-md-auto"
                      multiple="multiple"
                      @change="onFilterChange"
                  >
                    <option v-for="winelist in winelists" :key="winelist.id" :value="winelist.id">
                      {{ winelist.name }}
                    </option>
                  </select>
                </div>

                <!-- Production philosophy -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="philosophy">Filosofie produttive</label>
                  <select v-model="filters.philosophy" class="form-select" @change="onFilterChange">
                    <option value="">Tutti</option>
                    <option v-for="philosophy in philosophies" :key="philosophy.id" :value="philosophy.id">
                      {{ philosophy.name }}
                    </option>
                  </select>
                </div>

                <!-- Styles -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small">Stile</label>
                  <select v-model="filters.style" class="form-select" @change="onFilterChange">
                    <option value="">Tutti</option>
                    <option v-for="style in styles" :key="style.id" :value="style.id">
                      {{ style.name }}
                    </option>
                  </select>
                </div>

                <!-- Production Area -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small">Area di produzione</label>
                  <select v-model="filters.productionArea" class="form-select" @change="onFilterChange">
                    <option value="">Tutti</option>
                    <option v-for="production_area in production_areas" :key="production_area.id"
                            :value="production_area.id">
                      {{ production_area.name }}
                    </option>
                  </select>
                </div>

                <!-- Countries -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small">Nazione</label>
                  <select v-model="filters.country" class="form-select" @change="onCountryChange">
                    <option value="">Tutti</option>
                    <option v-for="country in countries" :key="country.id" :value="country.id">
                      {{ country.name }}
                    </option>
                  </select>
                </div>

                <!-- Regions -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small">Regione</label>
                  <select v-model="filters.region" class="form-select" @change="onFilterChange">
                    <option value="">Tutti</option>
                    <option v-for="region in regions" :key="region.id" :value="region.id">
                      {{ region.name }}
                    </option>
                  </select>
                </div>

                <!-- Strategy Actions -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="action">Azione</label>
                  <select v-model="filters.action" class="form-select w-md-auto" @change="onFilterChange">
                    <option value="">Strategie ({{ actions.length }})</option>
                    <option v-for="action in actions" :key="action.id" :value="action.id">
                      {{ action.name }}
                    </option>
                  </select>
                </div>

                <!-- New -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="new">Novità</label>
                  <select v-model="filters.new" class="form-select" @change="onFilterChange">
                    <option value="">Tutti</option>
                    <option value="si">Solo novità</option>
                    <option value="no">Tranne novità</option>
                  </select>
                </div>


                <!-- Collection -->
                <div class="mb-1" style="width:100%">
                  <label class="form-label mb-1 text-small" for="collection">Collezioni</label>
                  <select
                      id="collection"
                      v-model="filters.collection"
                      class="select2-with-tags w-md-auto"
                      multiple="multiple"
                      @change="onFilterChange"
                  >
                    <option v-for="collection in collections" :key="collection.id" :value="collection.id">
                      {{ collection.title }}
                    </option>
                  </select>
                </div>


                <!-- Order By -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="order_by">Order By</label>
                  <select v-model="filters.order_by" class="form-select" @change="onFilterChange">
                    <option value="">Tutti</option>
                    <option value="id_asc">ID Asc</option>
                    <option value="id_desc">ID Desc</option>
                    <option value="name_asc">Name A-Z</option>
                    <option value="name_desc">Name Z-A</option>
                    <option value="sku_asc">SKU Asc</option>
                    <option value="sku_desc">SKU Desc</option>
                    <option value="sale_price_asc">Sale Price (ITA) Asc</option>
                    <option value="sale_price_desc">Sale Price (ITA) Desc</option>
                  </select>
                </div>

                <!-- Price Filter - Input Fields Only -->
                <div class="mb-4 gap-3 w-100">
                  <div class="flex-fill">
                    <label class="form-label mb-1 text-small">Prezzo</label>
                    <div class="d-flex gap-1 mb-1">
                      <input v-model.number="filters.price_from" class="form-control form-control-sm" max="500"
                             min="0" placeholder="Min" type="number" @change="onFilterChange"/>
                      <input v-model.number="filters.price_to" class="form-control form-control-sm" max="500"
                             min="0" placeholder="Max" type="number" @change="onFilterChange"/>
                    </div>
                  </div>
                </div>

                <!-- Different Lowest Price -->
                <div class="mb-1" style="margin-right: 30px;">
                  <label class="form-label mb-1 text-small" for="differentLowestPrice">Different Lowest Price</label>
                  <div class="d-flex align-items-center gap-2">
                    <div class="form-check form-switch">
                      <input style="width: 50px !important; height: 23px !important;" v-model="filters.differentLowestPrice" class="form-check-input" type="checkbox" id="differentLowestPrice" @change="onFilterChange">
                    </div>
                  </div>
                </div>

                <!-- Discount Filter -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="discount">Discount</label>
                  <select
                      id="discount"
                      v-model="filters.discount"
                      class="select2-with-tags w-md-auto"
                      multiple="multiple"
                      @change="onFilterChange"
                  >
                    <option value="on_discount">On discount</option>
                    <option value="scheduled">Discount scheduled</option>
                    <option value="no_discount">No discount</option>
                  </select>
                </div>

                <!-- Quantity Discount Filter -->
                <div class="mb-1">
                  <label class="form-label mb-1 text-small" for="quantityDiscount">Quantity Discount</label>
                  <select
                      id="quantityDiscount"
                      v-model="filters.quantityDiscount"
                      class="form-select"
                      @change="onFilterChange"
                  >
                    <option value="">All</option>
                    <option value="yes">With quantity discount</option>
                    <option value="no">Without quantity discount</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal" type="button">Chiudi</button>
            <button class="btn btn-primary" type="button" @click="applyFilters">Filtra</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductFiltersModal',

  props: {
    initialFilters: {
      type: Object,
      default: () => ({})
    },
    search: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      filters: {
        enabled: 'all',
        outOfProduction: '',
        hasImages: '',
        search: '',
        brand: [],
        tag: [],
        collection: [],
        order_by: '',
        category: '',
        vintage: '',
        winelist: [],
        philosophy: '',
        style: '',
        country: '',
        region: '',
        productionArea: '',
        action: '',
        channel: '',
        productstatus: 'all',
        price_from: 0,
        price_to: '',
        bollini: [],
        handcrafted: '',
        new: '',

        differentLowestPrice: false,
        discount: [],
        quantityDiscount: ''
      },

      brands: [],
      tags: [],
      collections: [],
      subcategories: [],
      vintages: [],
      winelists: [],
      philosophies: [],
      styles: [],
      countries: [],
      regions: [],
      production_areas: [],
      actions: [],
      channels: [],
      statusList: [],
      todos: []
    }
  },

  watch: {
    search: {
      handler(newSearch) {
        this.filters.search = newSearch;
        this.onFilterChange();
      },
      immediate: true
    },
    initialFilters: {
      handler(newFilters, oldFilters) {
        // Only update if we have actual filter values and they're different
        if (newFilters && Object.keys(newFilters).length > 0) {
          // Merge URL filters with current filters, prioritizing URL filters
          // Only update if the filters actually changed to avoid unnecessary updates
          const hasChanges = !oldFilters || JSON.stringify(newFilters) !== JSON.stringify(oldFilters);
          
          if (hasChanges) {
            this.filters = {...this.filters, ...newFilters};
            
            // Update Select2 dropdowns if they exist (wait for DOM to be ready)
            this.$nextTick(() => {
              // Update Select2 for brand, tag, collection, etc.
              if (newFilters.brand && Array.isArray(newFilters.brand)) {
                const $brand = $('#brand');
                if ($brand.length) {
                  $brand.val(newFilters.brand).trigger('change');
                }
              }
              if (newFilters.tag && Array.isArray(newFilters.tag)) {
                const $tag = $('#tag');
                if ($tag.length) {
                  $tag.val(newFilters.tag).trigger('change');
                }
              }
              if (newFilters.collection && Array.isArray(newFilters.collection)) {
                const $collection = $('#collection');
                if ($collection.length) {
                  $collection.val(newFilters.collection).trigger('change');
                }
              }
              if (newFilters.winelist && Array.isArray(newFilters.winelist)) {
                const $winelist = $('#winelist');
                if ($winelist.length) {
                  $winelist.val(newFilters.winelist).trigger('change');
                }
              }
              if (newFilters.bollini && Array.isArray(newFilters.bollini)) {
                const $bollini = $('#bollini');
                if ($bollini.length) {
                  $bollini.val(newFilters.bollini).trigger('change');
                }
              }
              if (newFilters.discount && Array.isArray(newFilters.discount)) {
                const $discount = $('#discount');
                if ($discount.length) {
                  $discount.val(newFilters.discount).trigger('change');
                }
              }
              if (newFilters.category) {
                const $category = $('#category');
                if ($category.length) {
                  $category.val(newFilters.category).trigger('change');
                }
              }
            });
          }
        }
      },
      deep: true,
      immediate: false // Don't fire immediately, wait for actual filter values
    }
  },

  computed: {
    activeFilters() {
      const defaults = {
        enabled: 'all',
        outOfProduction: '',
        productstatus: 'all',
        price_from: 0,
        price_to: '',
        search: '',
        differentLowestPrice: false,
        discount: [],
        quantityDiscount: ''
      };

      const active = {};
      Object.keys(this.filters).forEach(key => {
        const currentValue = this.filters[key];
        const defaultValue = defaults[key];

        if (Array.isArray(currentValue)) {
          if (currentValue.length > 0) {
            active[key] = currentValue;
          }
        } else if (typeof currentValue === 'boolean') {
          // For boolean values, include if true (different from default false)
          if (currentValue === true) {
            active[key] = currentValue;
          }
        } else if (currentValue !== defaultValue && currentValue !== '') {
          active[key] = currentValue;
        }
      });

      return active;
    },

  },

  mounted() {
    this.initializeFilters();
    this.fetchFilterData();
    this.initSelect2();
    this.loadFiltersFromLocalStorage();
  },

  methods: {
    async fetchFilterData() {
      try {
        const response = await fetch('/comp/filters/all');
        const data = await response.json();
        this.brands = data.brands || [];
        this.tags = data.tags || [];
        this.collections = data.collections || [];
        this.subcategories = data.subcategories || [];
        this.vintages = data.vintages || [];
        this.winelists = data.winelists || [];
        this.philosophies = data.philosophies || [];
        this.styles = data.styles || [];
        this.countries = data.countries || [];
        this.regions = data.regions || [];
        this.production_areas = data.production_areas || [];
        this.actions = data.actions || [];
        this.channels = data.channels || [];
        this.statusList = data.statusList || [];
        this.todos = data.todos || [];
      } catch (error) {
        console.error('Error fetching filter data:', error);
      }
    },
    fetchRegions(countryId) {
      if (!countryId) {
        this.regions = [];
        return;
      }

      fetch(`/comp/filters/regions/${countryId}`)
          .then(response => response.json())
          .then(data => {
            this.regions = Array.isArray(data) ? data : (data.regions || []);

          })
          .catch(error => {
            console.error('Error fetching regions:', error);
          });
    },

    resetFilters() {
      this.filters = {
        enabled: 'all',
        outOfProduction: '',
        hasImages: '',
        search: '',
        brand: [],
        tag: [],
        winelist: [],
        collection: [],
        category: '',
        vintage: '',
        philosophy: '',
        style: '',
        productionArea: '',

        action: '',
        channel: '',
        country: '',
        region: '',
        price_from: 0,
        price_to: '',
        productstatus: 'all',
        bollini: [],
        handcrafted: '',
        new: '',
        order_by: '',
        differentLowestPrice: false,
        discount: [],
        quantityDiscount: ''
      };

      // Sync Select2 components after Vue data reset
      this.$nextTick(() => {
        if (typeof $.fn.select2 === 'function') {
          $('.select2, .select2-with-tags').val(null).trigger('change');
        }
      });

      this.$emit('filters-reset');
      this.$emit('active-filters', this.activeFilters);
    },

    applyFilters() {
      const modal = bootstrap.Modal.getInstance(document.getElementById('advancedFilters'));
      if (modal) {
        modal.hide();
      }
      this.saveFiltersToLocalStorage();
      this.$emit('apply-filters', this.activeFilters);
    },

    onFilterChange() {
      this.saveFiltersToLocalStorage();
    },

    onCountryChange() {
      if (this.filters.country) {
        this.fetchRegions(this.filters.country);
      } else {
        this.regions = [];
      }
      this.onFilterChange();
    },


    initSelect2() {
      if (typeof $.fn.select2 === 'function') {
        $('.select2, .select2-with-tags').select2({
          theme: "bootstrap4",
          closeOnSelect: true,
          placeholder: ' - Seleziona - ',
        });

        $(document).on('select2:close', '.select2, .select2-with-tags', (event) => {
          const element = event.target;
          const componentProp = element.id;
          if (this.filters[componentProp] !== undefined) {
             this.filters[componentProp] = $(element).val();
             this.onFilterChange();
          }
        });
      } else {
        console.warn('Select2 is not available. Dropdowns will fallback to standard selects.');
      }
    },

    saveFiltersToLocalStorage() {
      const filterData = {
        filters: this.filters,
        timestamp: new Date().toISOString(),
        user: this.getCurrentUserId()
      };

      localStorage.setItem('productFilters', JSON.stringify(filterData));
      window.dispatchEvent(new Event('filtersUpdated'));
    },

    loadFiltersFromLocalStorage() {
      const saved = localStorage.getItem('productFilters');
      if (saved) {
        try {
          const data = JSON.parse(saved);
          const oneDayAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);
          const savedTime = new Date(data.timestamp);

          if (savedTime > oneDayAgo && data.user === this.getCurrentUserId()) {
            this.filters = {...this.filters, ...data.filters};

            this.$nextTick(() => {
              this.onFilterChange();
            });
          }
        } catch (error) {
          console.error('Error loading saved filters:', error);
        }
      }
    },

    getCurrentUserId() {
      return document.querySelector('meta[name="user-id"]')?.getAttribute('content') || 'unknown';
    },

    initializeFilters() {
      if (this.initialFilters) {
        this.filters = {...this.filters, ...this.initialFilters};
      }
    }
  }
}
</script>

<style scoped>
.css-slider-container {
  position: relative;
}

.css-slider {
  position: absolute;
  width: 100%;
  pointer-events: none;
  -webkit-appearance: none;
  background: transparent;
  margin: 0;
}

.css-slider::-webkit-slider-thumb {
  pointer-events: all;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #007bff;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.css-slider::-moz-range-thumb {
  pointer-events: all;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #007bff;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.css-slider-track {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 4px;
  border-radius: 2px;
  transform: translateY(-50%);
}

.css-slider-max {
  z-index: 2;
}

.css-slider-min {
  z-index: 1;
}

input[type="number"] {
  text-align: center;
}

.modal-right .modal-dialog {
  position: fixed;
  top: 0;
  right: 0;
  margin: 0;
  width: 25vw;
  max-width: 100vw;
  height: 100vh;
  border-radius: 0;
  z-index: 1050;
}

.modal-right .modal-content {
  height: 100vh;
  border-radius: 0;
  display: flex;
  flex-direction: column;
}

.modal-right .modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem;
}

@media (max-width: 768px) {
  .modal-right .modal-dialog {
    width: 100vw;
    max-width: 100vw;
  }
}

</style>